import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from "react-bootstrap";
import DataTable from 'react-redux-datatable';
import 'react-redux-datatable/dist/styles.css';
import {apibaseURL } from "../../../../config";
import { fetchDocketData,findDockets } from '../../../../actions/docketAction';
import {mediaPath } from "../../../../config";
import { Link,NavLink,withRouter } from "react-router-dom";
import { history } from "../../../../services/helper/Helper";


class DisplayDockets extends Component {

	render() {
		return (
			<div>
				<DataTable
                          tableSettings={{
                            status:this.props.status,
                            tableID: 'DataTable',
                            keyField: 'caseid',
														paginationPerPage: 1,
														paginationRowsPerPageOptions:[25,50,100],
														limit:25,
                            noDataIndication: 'No Results Found.',
                            tableColumns: [
														{
                                    title: 'Docket #  ',
                                    key: 'caseid',
                                             
                                    dataFormat:(data,obj) => <NavLink to={'/publicAccess/docketInfo/'+btoa(obj.caseid)} exact>{obj.caseid}</NavLink>               
                            },
														{
                                    title: 'Petitioner ',
                                    key: 'petitionerFullName',
																dataFormat:(data,obj) => ((obj.petitionerFullName!=null && obj.petitionerFullName!='') ? obj.petitionerFullName : (obj.petitioner!=null && obj.petitioner!='') ? obj.petitioner : 'No Party Added')
														},
														{
																title: 'Respondent ',
																key: 'respondentFullName',
																dataFormat:(data,obj) => ((obj.respondentFullName!=null && obj.respondentFullName!='') ? obj.respondentFullName : (obj.respondent!=null && obj.respondent!='') ? obj.respondent : 'No Party Added')
														},   
														{
																title: 'Status ',
																key: 'status'
														},
														{
																title: 'Hearing Date ',
																key: 'hearingdate'
														},
														{
																title: 'Date Received ',
																key: 'datereceivedbyOSAH'
														},
														// {
														// 		title: 'eService ',
														// 		key: 'opt-in',
														// 		sortable: false,
														// 		dataFormat:(data,obj) => ((obj.e_services!=null && obj.e_services!='0') ? <div className="optedtooltip-block"><div class="optedin"><i class="fa fa-check-circle" aria-hidden="true"></i> <span>Opted-In</span></div><span className="tooltiptext" >By opting in to eService, you are consenting to receive all filings from the Court electronically.  You also consent for any opposing parties of record to serve you electronically through ePortal, and <b>you thereby waive the right to service by the means described under Ga. Comp. R. & Regs. 616-1-2-.11.</b>  Any service requirements otherwise provided by law shall remain in effect.</span></div> : <div className="optedtooltip-block"><div class="optedout"><i class="fa fa-pause" aria-hidden="true"></i> <span>Opted-Out</span></div><span className="tooltiptext" >By opting in to eService, you are consenting to receive all filings from the Court electronically.  You also consent for any opposing parties of record to serve you electronically through ePortal, and <b>you thereby waive the right to service by the means described under Ga. Comp. R. & Regs. 616-1-2-.11.</b>  Any service requirements otherwise provided by law shall remain in effect.</span></div>)
														// },
														{
																title: '',
																key: '',
																sortable: false,
																dataFormat:(data,obj) => (<button aria-label="View" type="button" role="button" onClick={()=>{history.push('/publicAccess/docketInfo/'+btoa(obj.caseid))}}>View</button>)
														},
																
								],
                        }}
                          apiLocation={apibaseURL+"getMydockets"}
                        
                        /> 
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		docketGeneralInfo: state.docketGeneralInfo,
	};
}

export default connect(mapStateToProps, { fetchDocketData,findDockets })(DisplayDockets);